import React from "react";
import { useSnapshot } from "valtio";

import { store as userStore } from "@components/VerticalLayout/store";

import { PrinterSettingModal } from "./PrinterSettingModal";
import { MenuWrapper } from "./MenuWrapper";
import { PrinterFooter } from "./PrinterFooter";
import { useModeOfSale } from "./hooks";
import { PrinterRowData, PrinterSettingConfig } from "./types";

import GeneralPanelSetting from "./tabs/General";
import ClientPanelSetting from "./tabs/CustomerTicket";
import KitchenPanelSetting from "./tabs/KitchenTicket";
import ModeleTicket from "./tabs/ModeleTicket";
import Divers from "./tabs/Divers";

const DEFAULT_SHOP_ID = "";

export type PrinterSettingComposedProps = {
    isOpen: boolean;
    onClose: () => void;
    rowData: PrinterRowData;
    oneShop: boolean;
    config: PrinterSettingConfig;
    onSaved?: () => void;
};

export function PrinterSetting({
    isOpen,
    onClose,
    rowData,
    oneShop,
    config,
    onSaved,
}: PrinterSettingComposedProps): JSX.Element {
    const { shopID, userID, franchiseID } = useSnapshot(userStore);
    const shopId = oneShop
        ? String(shopID)
        : (rowData.shopId as string | undefined) ?? DEFAULT_SHOP_ID;

    const modeOfSaleEndpoint = `${config.endpoints.fetchModeOfSale}?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;

    const { rawSalesModes } = useModeOfSale({
        enabled: isOpen,
        endpoint: modeOfSaleEndpoint,
        appId: config.appId,
        rowData,
    });

    return (
        <PrinterSettingModal
            isOpen={isOpen}
            onClose={onClose}
            title={config.titleTemplate(rowData)}
            footer={
                <PrinterFooter
                    config={config}
                    rowData={rowData}
                    oneShop={oneShop}
                    onClose={onClose}
                    onSaved={onSaved}
                />
            }
        >
            <MenuWrapper
                rowData={rowData}
                tabRenderers={{
                    general: <GeneralPanelSetting rowData={rowData} />,
                    customerTicket: (
                        <ClientPanelSetting
                            rowData={rowData}
                            oneShop={oneShop}
                        />
                    ),
                    kitchenTicket: (
                        <KitchenPanelSetting
                            rowData={rowData}
                            oneShop={oneShop}
                            salesModesData={rawSalesModes}
                            appId={config.appId}
                        />
                    ),
                    modeleTicket: (
                        <ModeleTicket rowData={rowData} oneShop={oneShop} />
                    ),
                    divers: <Divers rowData={rowData} oneShop={oneShop} />,
                }}
            />
        </PrinterSettingModal>
    );
}
